import { Switch } from '@mui/material';
import { compact } from 'lodash';
import React, { useState } from 'react';

import { updateProfile } from '../../utils/backend-api/userProfile';
import StepContainer from './StepContainer';

const StepInterests = ({ interests, nextStep }) => {
  const [selectedInterests, setSelectedInterests] = useState(
    compact(interests.map((i) => (i.default ? i.key : null)))
  );
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState();

  const handleSwitchToggle = (event) => {
    setSelectedInterests(
      selectedInterests.includes(event.target.value)
        ? selectedInterests.filter((prevKey) => prevKey !== event.target.value)
        : [...selectedInterests, event.target.value]
    );
  };

  return (
    <StepContainer
      heading="Be The First to Know"
      subheading="What would you like to be updated on?"
      nextStep={nextStep}
      disableContinue={isSaving}
      error={error}
      onContinue={async () => {
        setIsSaving(true);
        try {
          await updateProfile({ interests: selectedInterests });
          nextStep();
        } catch (err) {
          setError(err.message);
        }
        setIsSaving(false);
      }}
    >
      <ul className="onboarding-togglelist">
        {interests?.map((i) => (
          <li key={i.key}>
            {i.label}
            <Switch
              className="tiswitch"
              disableRipple
              defaultChecked={i.default}
              onChange={handleSwitchToggle}
              value={i.key}
            />
          </li>
        ))}
      </ul>
    </StepContainer>
  );
};

export default StepInterests;
